export default __webpack_public_path__ + "static/media/dpl.6d58a1c3.png";